// extracted by mini-css-extract-plugin
export var tosLink = "_44-0";